import { render } from "./DashboardSpaceDetailContainer.vue?vue&type=template&id=d6878828"
import script from "./DashboardSpaceDetailContainer.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceDetailContainer.vue?vue&type=script&lang=js"
script.render = render

export default script